import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_PERFORMANCE,
  DELETE_PERFORMANCE,
  UPDATE_PERFORMANCE,
  ADD_NEW_PERFORMANCE,
} from "./actionType";

import {
  getPerformanceSuccess,
  getPerformanceFail,
  deletePerformanceSuccess,
  deletePerformanceFail,
  updatePerformanceSuccess,
  updatePerformanceFail,
  addPerformanceSuccess,
  addPerformanceFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  approvePerformanceApi,
  getPerformanceApi,
  updatePerformanceApi,
  deletePerformanceApi,
  addNewPerformanceApi
} from "../../helpers/backend_helper";

function* getPerformance({ payload: performance }) {
  try {
    const response = yield call(getPerformanceApi, performance);
    yield put(getPerformanceSuccess(GET_PERFORMANCE, response.data));
  } catch (error) {
    yield put(getPerformanceFail(GET_PERFORMANCE, error));
  }
}

function* onUpdatePerformance({ payload: performance }) {
  try {
    if (performance.setApprove) {
      const response = yield call(approvePerformanceApi, performance);
      yield put(updatePerformanceSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updatePerformanceApi, performance);
      yield put(updatePerformanceSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updatePerformanceFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeletePerformance({ payload: performance }) {
  try {
    const response = yield call(deletePerformanceApi, performance);
    yield put(deletePerformanceSuccess({ performance, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deletePerformanceFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewPerformance({ payload: performance }) {
  try {
    const response = yield call(addNewPerformanceApi, performance);
    yield put(addPerformanceSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addPerformanceFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetPerformance() {
  yield takeEvery(GET_PERFORMANCE, getPerformance);
}

export function* watchUpdatePerformance() {
  yield takeEvery(UPDATE_PERFORMANCE, onUpdatePerformance);
}

export function* watchDeletePerformance() {
  yield takeEvery(DELETE_PERFORMANCE, onDeletePerformance);
}

export function* watchAddNewPerformance() {
  yield takeEvery(ADD_NEW_PERFORMANCE, onAddNewPerformance);
}

function* performanceSaga() {
  yield all([
    fork(watchGetPerformance),
    fork(watchDeletePerformance),
    fork(watchUpdatePerformance),
    fork(watchAddNewPerformance)
  ]);
}

export default performanceSaga;
